import axios from "axios";
import { GetCorpResponse, CreateCorpInfoRequest, UpdateCorpInfoRequest, UpdateCorpIconRequest} from "./dto/CorpInfo";

const toUpdateCorpInfoRequest = (
  corpInfo: GetCorpResponse,
): UpdateCorpInfoRequest => {
  return {
    corporateId: corpInfo.corporateId,
    corporateName: corpInfo.corporateName,
    divisionName: corpInfo.divisionName,
    corporateNameKana: corpInfo.corporateNameKana,
    corporateRepresentative: corpInfo.corporateRepresentative,
    corporateRepresentativeKana: corpInfo.corporateRepresentativeKana,
    contactMailAddress: corpInfo.contactMailAddress,
    phoneNumber: corpInfo.phoneNumber,
    fax: corpInfo.fax,
    paymentType: corpInfo.paymentType,
  };
};

/**
 * 法人情報登録API
 * @param corpInfo 登録する法人情報
 * @returns
 */
export const createCorpInfo = async (
  req: CreateCorpInfoRequest
): Promise<GetCorpResponse> => {
  const res = await axios.post<GetCorpResponse>("/api/corporation", req, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

/**
 * 法人情報更新API
 * @param corpInfo 更新する法人情報
 * @returns
 */
export const updateCorpInfo = async (
  corpInfo: GetCorpResponse,
): Promise<GetCorpResponse> => {
  const req = toUpdateCorpInfoRequest(corpInfo);
  const res = await axios.put<GetCorpResponse>(`/api/corporation?id=${corpInfo.id}`, req, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

/**
 * 法人アイコン更新API
 * @param req 法人アイコン更新リクエスト
 * @returns
 */
export const updateCorpIcon = async (
  req: UpdateCorpIconRequest,
): Promise<GetCorpResponse> => {
  const data = toFormData(req as unknown as Record<string, unknown>);
  const res = await axios.post<GetCorpResponse>(`/api/corporation/icon`, data, {
    headers: { "Content-Type": "multipart/form-data", },
  });
  return res.data;
};

/**
 * 法人情報を取得する
 */
export const getCorpInfo = async (): Promise<GetCorpResponse> => {
  return axios.get<GetCorpResponse>(`/api/corporation`).then((res) => res.data);
};

export const corporateNameCat = (str1: string, str2: string): string => {
  return str1 + ' ' + str2;
};

export const corporateNameSplit = (str: string): Array<string> => {
  return str.split(' ');
};

// {} をFormDataに変換する
const toFormData = (req: Record<string, unknown>): FormData => {
  const data = new FormData();
  for (const [k, v] of Object.entries(req)) {
    if (v === null) {
      continue;
    }
    if (v instanceof Blob) {
      data.set(k, v);
    } else if (typeof v !== "object") {
      data.set(k, `${v}`);
    } else {
      // NOTE: FormData の値は string | Blob なので object は stringify() する
      data.set(k, JSON.stringify(v));
    }
  }
  return data;
};